<template>
  <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    <el-upload
      :action="currentField.uploadURL"
      :auto-upload="true"
      :show-file-list="true"
      accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      :before-remove="beforeRemove"
      :limit="1"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :on-success="successFileUpload"
      :on-remove="removeFileUpload"
      multiple
    >
      <!-- :action="currentField.uploadURL" -->
      <el-button size="small" type="primary">Click to upload</el-button>
    </el-upload>
  </el-form-item>
</template>

<script>
export default {
  name: 'Upload',
  props: ['currentField'],
  data() {
    return {
      fileList: []
    };
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${files.length} files this time, add up to ${
          files.length + fileList.length
        } totally`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    successFileUpload(response, file, fileList) {
      this.currentField.componentValue.push(response);
    },
    removeFileUpload(file, fileList) {
     
    }
  }
};
</script>

<style scoped>
@import './FormElementUpload.css';
</style>
